import React from 'react';

import styles from './Maintenance.module.scss';

const Maintenance = () => {
    return (
        <div className={styles.wrapper}>
            <div className={styles.textMessage}>
                ただいまメンテナンス中です。
                <br/>
                ただいまメンテナンスのため一時サービスを停止しております。
                大変ご不便をおかけいたしますが、今しばらくお待ちください。
            </div>
        </div>
    );
};

export default Maintenance;